import type { ReactNode } from 'react';

import {
  ListingViewSectionHolder,
  ListingViewSectionTitle,
} from './ListingViewSection.styled';

type Props = {
  id?: string;
  title?: string;
  children: ReactNode;
  noBorderTop?: boolean;
};

export function ListingViewSection({
  id,
  title,
  children,
  noBorderTop,
}: Props) {
  return (
    <ListingViewSectionHolder id={id} $noBorderTop={Boolean(noBorderTop)}>
      {title ? (
        <ListingViewSectionTitle>{title}</ListingViewSectionTitle>
      ) : null}

      {children}
    </ListingViewSectionHolder>
  );
}
